{
  "meta": {
    "title": "Businesses",
    "manageAndSwitch": "Manage and switch between your businesses"
  },
  "actions": {
    "import": "Import",
    "createBusiness": "Create Business",
    "createBusinessOrInstitution": "Create Business or Institution",
    "createNewBusiness": "Create new business",
    "switchTo": "Switch to",
    "back": "Back",
    "backToBusinesses": "Back to Businesses",
    "actions": "Actions",
    "editBusiness": "Edit Business",
    "deleteBusiness": "Delete Business",
    "cancel": "Cancel",
    "saveChanges": "Save Changes",
    "saving": "Saving",
    "uploadingImage": "Uploading image...",
    "makePrimary": "Make primary",
    "makePrimaryConfirm": "Make this location the primary location for this organization?",
    "makePrimarySuccess": "Primary location updated",
    "makePrimaryError": "Update failed",
    "view": "View"
  },
  "empty": {
    "noBusinessesYet": "No businesses yet",
    "createFirstOrImport": "Create your first business or import multiple at once from Excel.",
    "selectFromList": "Select a business from the list",
    "clickToViewDetails": "Click on a business to view its details",
    "searchNoMatch": "No businesses match your search"
  },
  "labels": {
    "unnamedBusiness": "Unnamed Business",
    "unnamed": "Unnamed",
    "branch": "Branch",
    "primary": "Primary",
    "noDescription": "No description",
    "noDescriptionAvailable": "No description available",
    "contactAndLocation": "Contact & location",
    "quickLinks": "Quick links",
    "quickLinksDesc": "Manage this business across the platform",
    "businessProfile": "Business profile",
    "services": "Services",
    "appointments": "Appointments",
    "income": "Income",
    "searchBusinessesPlaceholder": "Search businesses...",
    "noContactInfo": "No contact information",
    "moreFromBusiness": "More from this business",
    "moreFromBusinessDesc": "Other locations linked to this organization"
  },
  "columns": {
    "name": "Business",
    "industry": "Industry",
    "location": "Location",
    "type": "Type"
  },
  "show": {
    "businessDetails": "Business Details",
    "businessNotFound": "Business not found",
    "businessNotFoundDesc": "The business you're looking for doesn't exist or has been removed.",
    "overview": "Overview",
    "analytics": "Analytics",
    "settings": "Settings",
    "createdOn": "Created on {{date}}",
    "contactInfo": "Contact Information",
    "contactInfoDesc": "Business contact details and location",
    "email": "Email",
    "phone": "Phone",
    "location": "Location",
    "owner": "Business Owner",
    "ownerDesc": "Information about the business owner",
    "financial": "Financial Information",
    "financialDesc": "Bank account details for payments",
    "bankName": "Bank Name",
    "accountNumber": "Account Number",
    "fulfillmentRateTitle": "Service Fulfillment Rate",
    "fulfillmentRateDesc": "Percentage of services successfully completed",
    "fulfillmentRate": "Fulfillment Rate",
    "reportsTitle": "Customer issues",
    "reportsDesc": "Appointment disputes from customers",
    "totalReports": "Total customer issues",
    "quickStats": "Quick Stats",
    "quickStatsDesc": "Overview of business performance metrics",
    "performance": "Performance",
    "status": "Status",
    "industry": "Industry",
    "active": "Active",
    "blocked": "Blocked",
    "businessSettings": "Business Settings",
    "businessSettingsDesc": "Manage business configuration and preferences",
    "businessStatus": "Business Status",
    "currentStatus": "Current status: {{status}}",
    "approvalStatus": "Approval Status",
    "approvalState": "Business approval state",
    "editBusinessSettings": "Edit Business Settings",
    "viewDetailsDesc": "View detailed information about this business"
  },
  "edit": {
    "title": "Edit Business",
    "description": "Update your business information",
    "businessInformation": "Business Information",
    "businessInformationDesc": "Update the details of your business",
    "businessLogo": "Business Logo",
    "businessName": "Business name",
    "businessNamePlaceholder": "Enter business name",
    "businessDescription": "Business description",
    "businessDescriptionPlaceholder": "Describe your business",
    "industry": "Industry",
    "industryPlaceholder": "Select an industry",
    "industrySearchPlaceholder": "Search industries...",
    "industryEmpty": "No industry found",
    "businessEmail": "Business email",
    "businessEmailPlaceholder": "business@example.com",
    "businessPhone": "Business phone",
    "businessPhonePlaceholder": "+1234567890",
    "locationRequired": "Location is required",
    "updatedSuccess": "Business updated successfully",
    "updateError": "Error updating business",
    "location": "Location",
    "locationPlaceholder": "Search for an address"
  },
  "create": {
    "title": "Create Business or Institution",
    "branchTitle": "Add a new location",
    "branchDescription": "Create another location linked to {{name}}.",
    "chooseType": {
      "title": "What are you creating?",
      "description": "Choose whether this is a new standalone business or a branch location under an existing one.",
      "standaloneTitle": "Standalone business",
      "standaloneDescription": "A separate business with its own organization.",
      "branchTitle": "Branch location",
      "branchDescription": "A new location linked to {{name}}.",
      "branchDescriptionFallback": "A new location linked to your current business.",
      "cancel": "Cancel"
    },
    "descriptionPrefix": "Follow the steps below to create your business or institution. Need to add many?",
    "importViaExcel": "Import via Excel",
    "steps": {
      "infoTitle": "Business or Institution Information",
      "infoDesc": "Enter the basic information about your business or institution",
      "locationTitle": "Location & Contact",
      "locationDesc": "Add your business or institution location and contact details",
      "planTitle": "Choose plan",
      "planDesc": "Select Starter or Premium for your business",
      "documentsTitle": "Documents",
      "documentsDesc": "Upload required business or institution documents"
    },
    "toasts": {
      "uploadFailedPrefix": "Upload failed:",
      "uploadDocFailed": "Failed to upload document. Please try again.",
      "uploadImageFailed": "Failed to upload image. Please try again.",
      "createdSuccess": "Business or institution created successfully",
      "createError": "Error creating business or institution",
      "fillAllRequired": "Please fill in all required fields",
      "coordsNotFound": "Could not find coordinates for this address. Pick a suggestion from the list or check your address.",
      "uploadRequiredDoc": "Please upload the required document",
      "locationDenied": "Location access denied or unavailable"
    },
    "next": {
      "next": "Next",
      "nextWithTitle": "Next: {{title}}"
    }
  },
  "createSteps": {
    "ownerEmail": "Business or institution owner email",
    "ownerEmailPlaceholder": "owner@example.com",
    "logo": "Business or Institution Logo",
    "name": "Business or institution name",
    "namePlaceholder": "Enter business or institution name",
    "description": "Business or institution description",
    "descriptionPlaceholder": "Describe your business or institution",
    "industry": "Industry",
    "industryPlaceholder": "Select an industry",
    "industrySearchPlaceholder": "Search industries...",
    "industryEmpty": "No industry found",
    "whereLocated": "Where is your business or institution located?",
    "location": "Location",
    "locationHelp": "Start typing your address and choose a suggestion from the list to set your exact location.",
    "locationPlaceholder": "e.g. 123 Main Street, Accra",
    "contactHeader": "How can we contact you?",
    "email": "Business or institution email",
    "phone": "Business or institution phone number",
    "documents": {
      "requirements": "Requirements:",
      "pdfOnly": "Should be of PDF format",
      "singlePdf": "Upload all documents as a single PDF",
      "registrationDocs": "Should contain business or institution registration and incorporation documents",
      "ids": "Should contain the Ghana Card or Passport of two business or institution directors",
      "documentLabel": "Business or Institution Document"
    },
    "locationPermission": {
      "allowTitle": "Allow location access?",
      "failedTitle": "Location access failed",
      "autoFillDesc": "We can auto-fill your location to make setup faster. You can still edit it manually anytime.",
      "tryAgainOrManual": "You can try again or enter your address manually.",
      "enterManually": "Enter manually",
      "tryAgain": "Try again",
      "allowLocation": "Allow location",
      "detecting": "Detecting location..."
    }
  },
  "import": {
    "title": "Import Businesses",
    "description": "Bulk import businesses using an Excel template",
    "templateDownloaded": "Template downloaded",
    "instructions": "Instructions",
    "downloadTemplate": "Download template",
    "downloadTemplateHelp": "Get the Excel template and fill in your business data according to the column headers.",
    "downloadTemplateBtn": "Download template",
    "uploadFilledTemplate": "Upload filled template",
    "uploadFilledTemplateHelp": "Upload your completed Excel file to import businesses in bulk.",
    "foundCount": "{{count}} business{{plural}} found",
    "importing": "Importing...",
    "importBtn": "Import businesses",
    "parseNone": "No valid business rows found. Ensure the file has a header row and at least one row with a business name and phone number.",
    "parseFailed": "Failed to parse Excel file. Please check the file format.",
    "selectFileFirst": "Please select a file first",
    "noValidBusinesses": "No valid businesses found. Ensure each row has name and phone.",
    "importedSuccess": "Businesses imported successfully",
    "importFailed": "Failed to import businesses",
    "requiredColumnsTitle": "Required columns",
    "requiredColumnsDesc": "Your Excel file must include these columns:",
    "required": {
      "name": "Business name (5–150 characters)",
      "phone": "Business phone number",
      "optional": "Optional: description, industry, email, location, image, document, latitude, longitude, parentBusiness (existing business id)"
    }
  },
  "dialogs": {
    "createBusinessDialog": {
      "title": "Create Your Business or Institution",
      "description": "To fully utilize the system and access all features like services, appointments, income management, and more, you need to create a business or institution first.",
      "dontShowAgain": "Don't show this again",
      "dismiss": "Dismiss"
    }
  }
}
